import type { MasterScriptData, ScriptStep, StepType } from '../types/steps';

/**
 * Model-agnostic default a new master script starts from: pick the DMM up from
 * its rack slot via the {{slot}} token the engine resolves per run (A1 on a bench
 * run, the cell label on a work-order walk), no test points yet, and return it.
 * No model profile-load — that is chosen per run. Mirrors the backend create_script
 * seed (MCP ScriptTools).
 */
export const DEFAULT_MASTER_TEMPLATE: MasterScriptData = {
  pickupSteps: [{ action: 'DMM_FROM_{{slot}}_TO_BED' }],
  items: [],
  returnSteps: [{ action: 'RETURN_DMM' }]
};

export const buildDefaultMasterScriptData = (): string =>
  JSON.stringify(DEFAULT_MASTER_TEMPLATE, null, 2);

/** Runtime defaults applied by the engine when values are absent from JSON */
export const RUNTIME_DEFAULTS = {
  timeoutMs: {
    command: 240000,
    wait: 0,
    measure: 15000,
    get_result_and_pic: 15000
  },
  qos: 1 as const,
  maxRetries: 0,
  onFailure: 'abort' as const
};

const COMMAND_DEFAULTS: ScriptStep = {
  action: ''
};

const WAIT_DEFAULTS: ScriptStep = {
  type: 'wait',
  durationMs: 1000
};

const MEASURE_DEFAULTS: ScriptStep = {
  type: 'measure',
  action: '',
  targetField: 'asFound'
};

const GET_RESULT_AND_PIC_DEFAULTS: ScriptStep = {
  type: 'get_result_and_pic',
  action: 'TAKE_PIC_CROP_GET_GPT_RESULT',
  targetField: 'asFound'
};

const DEFAULTS_MAP: Record<StepType, ScriptStep> = {
  command: COMMAND_DEFAULTS,
  wait: WAIT_DEFAULTS,
  measure: MEASURE_DEFAULTS,
  get_result_and_pic: GET_RESULT_AND_PIC_DEFAULTS
};

export const getStepDefaults = (type: StepType): ScriptStep =>
  JSON.parse(JSON.stringify(DEFAULTS_MAP[type]));
